module.exports = __webpack_public_path__ + "static/media/shift-schedule.9c1fa7d8.png";